// extracted by mini-css-extract-plugin
export default {"statusTabButton":"StatusTabs_statusTabButton__mntP2","tabGroup":"StatusTabs_tabGroup__v0LnV","statusTabsContainer":"StatusTabs_statusTabsContainer__o2xX7"};